export enum ECacheKeys {
	FinanceCharges = 'FinanceCharges',
	Authentications = 'Authentications',
	Overviews = 'Overviews',
}
